export const COMPANIES = {
  ADENTIS_PORTUGAL: "ade71500-a6a9-4866-9518-1d15c3065689",
  AGAP2_IT_INTERNATIONAL: "a2017000-00bb-4504-9b70-efe74f43cea4",
  AGAP2_PORTUGAL: "437cd556-afdf-4ab6-bae7-4745a57dd7a8",
  BEE_ENGINEERING_PORTUGAL: "bee00002-d121-451b-be2c-8b2b541e7da2",
  MOONGY: "moongy-tenant-id-placeholder",
  CODEWIN: "74970d55-a1bc-4315-b73e-c4a3533f252a",
  KCS_IT: "517c6ef2-b14e-4bf5-b358-cbe6f1896dc7",
  TEAM_IT_PORTUGAL: "73401797-1ca3-4c43-85e2-b2bba7ee8ca0",
};

export const COMPANY_NAMES = {
  [COMPANIES.ADENTIS_PORTUGAL]: "Adentis Portugal",
  [COMPANIES.AGAP2_IT_INTERNATIONAL]: "Agap2 IT International",
  [COMPANIES.AGAP2_PORTUGAL]: "Agap2 Portugal",
  [COMPANIES.BEE_ENGINEERING_PORTUGAL]: "Bee Engineering Portugal",
  [COMPANIES.CODEWIN]: "CodeWin",
  [COMPANIES.MOONGY]: "Moongy",
  [COMPANIES.KCS_IT]: "KCS IT",
  [COMPANIES.TEAM_IT_PORTUGAL]: "Team-IT Portugal",
};

export const getCompanyName = (companyId) => {
  if (!companyId) return null;
  const normalizedId = companyId.toLowerCase();
  return COMPANY_NAMES[normalizedId] || null;
};

export const getCompanyTenant = (companyId) => {
  if (!companyId) return null;

  const normalizedId = companyId.toLowerCase();

  if (normalizedId === COMPANIES.ADENTIS_PORTUGAL.toLowerCase())
    return "adentis";
  if (normalizedId === COMPANIES.BEE_ENGINEERING_PORTUGAL.toLowerCase())
    return "bee";
  if (
    normalizedId === COMPANIES.AGAP2_IT_INTERNATIONAL.toLowerCase() ||
    normalizedId === COMPANIES.AGAP2_PORTUGAL.toLowerCase()
  )
    return "agap2";
  if (normalizedId === COMPANIES.KCS_IT.toLowerCase()) return "kcs";
  if (normalizedId === COMPANIES.MOONGY.toLowerCase()) return "moongy";
  if (normalizedId === COMPANIES.CODEWIN.toLowerCase()) return "codewin";
  if (normalizedId === COMPANIES.TEAM_IT_PORTUGAL.toLowerCase())
    return "teamit";

  return "moongy";
};
